<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeCheckmarkCircle from "@dsk/icons/LeCheckmarkCircle.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";

import LeActivationMailSentToast from "@/components/toasts/LeActivationMailSentToast.vue";
import { config } from "@/config";
import { UserService } from "@/services";

import LeErrorResult from "./LeErrorResults.vue";

const toast = useToast();
const i18n = useI18n();
const { t } = i18n;

const activationMailSent = ref(false);

const sendActivationMail = async () => {
  const { email } = await UserService.sendActivationMail();

  activationMailSent.value = true;

  toast.info(
    {
      component: LeActivationMailSentToast,
      props: {
        i18n,
        email
      }
    },
    { icon: LeCheckmarkCircle }
  );
};
</script>

<template>
  <LeErrorResult>
    <template #header>
      {{ t("le-error-results.user-not-activated.headline") }}
    </template>
    <template #paragraph1>
      {{ t("le-error-results.user-not-activated.paragraph", { site: config.app.site }) }}
    </template>
    <template #button>
      <LeButton :disabled="activationMailSent" variant="outline" @click="sendActivationMail()">{{
        t("le-error-results.user-not-activated.button")
      }}</LeButton>
    </template>
  </LeErrorResult>
</template>
